import React from 'react';
import ReactTooltip from "react-tooltip";

const Tooltip: React.FC<{
  text: string;
}> = ({ text }) => {
  return (
    <>
      <i className='fas fa-info-circle' data-tip={text}></i>
      <ReactTooltip place="top" type="dark" effect="float" />
    </>
  )
}

export default Tooltip
